import { render, staticRenderFns } from "./AtualizarProdutosCotacao.vue?vue&type=template&id=d56223b8&scoped=true&"
import script from "./AtualizarProdutosCotacao.vue?vue&type=script&lang=js&"
export * from "./AtualizarProdutosCotacao.vue?vue&type=script&lang=js&"
import style0 from "./AtualizarProdutosCotacao.vue?vue&type=style&index=0&id=d56223b8&prod&lang=scss&scoped=true&"
import style1 from "./AtualizarProdutosCotacao.vue?vue&type=style&index=1&id=d56223b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56223b8",
  null
  
)

export default component.exports